import styled from 'styled-components';
import { TOP_BANNER_HEIGHT } from '@/components/Banners/Banners.constants';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const EmptyCollectionList = styled.div<{
  $isTopBannerVisible: boolean;
}>`
  display: flex;
  height: 100%;
  flex-grow: 1;
  padding: 15% 30px;
  align-items: center;
  flex-direction: column;
  text-align: center;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 30% 30px 0 30px;
    min-height: ${({ $isTopBannerVisible, theme }) =>
      `calc(100vh - ${
        theme.tabBarHeight +
        TOP_BANNER_HEIGHT +
        ($isTopBannerVisible ? TOP_BANNER_HEIGHT : 0)
      }px)`};
  }
`;

export const Title = styled(Typography.Header).attrs({
  $variant: '0',
})`
  margin-bottom: 10px;
`;

export const Description = styled(Typography.Caption).attrs({
  $variant: '1',
})`
  margin-bottom: 35px;
`;

export const AddButton = styled(Button)`
  font-size: 13px;
`;
